import {all, call, takeLatest} from 'redux-saga/effects';
import * as constants from '../constants';
import * as actions from '../actions/action_export';

function* exportSurveyComplete({payload}) {
    yield call(actions.surveyExportComplete, payload.id);
}

function* exportDashboardComplete({payload}) {
    yield call(actions.dashboardExportComplete, payload.id);
}

export default function* root() {
    yield all([
        takeLatest(constants.SURVEY_EXPORT_COMPLETE, exportSurveyComplete),
        takeLatest(constants.DASHBOARD_EXPORT_COMPLETE, exportDashboardComplete),
    ]);
}
